module.exports = __webpack_public_path__ + "static/06-SEN-VINO-DE-PALMERA.87897eeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/beverages/06-SEN-VINO-DE-PALMERA.png
// module id = 600
// module chunks = 35783957827783